import React, { useContext } from 'react';
import { AuthContext } from '../auth/AuthContext';
import { UserGroup } from '@round/api';
import { Navigate } from 'react-router-dom';

const defaultGroupRoutes: { [key in UserGroup]?: string } = {
    apex_client: '/client/campaigns/',
    apex_community_manager: '/campaign-manager/bookings/',
    apex_brand_partnership_manager: '/campaign-manager/bookings/',
    apex_manager: '/campaign-manager/bookings/',
    apex_finance: '/finance/creator-payments/',
    apex_admin: '/admin/bookings/',
};

const RedirectToDefault = () => {
    const authContext = useContext(AuthContext);
    const groups = (authContext.user?.groups ?? []).filter((group) => group.startsWith('apex'));
    const defaultGroup = Object.keys(defaultGroupRoutes).find((group) =>
        groups.includes(group as UserGroup)
    ) as UserGroup;
    const redirect = (defaultGroup && defaultGroupRoutes[defaultGroup]) || '/unauthorised/';

    if (authContext.loading) {
        return null;
    }

    if (!authContext.authenticated) {
        return <Navigate to="/roster/" />;
    }

    return <Navigate to={redirect} />;
};

export default RedirectToDefault;
